import React from 'react';
import { useParams } from 'react-router-dom';
import LiveVisualEditor from '../components/editor/VisualEditor';

const Editor = () => {
  const { clientId } = useParams();

  return (
    <div className="h-screen flex flex-col bg-gray-100">
      <div className="bg-white border-b px-6 py-3 flex justify-between items-center shadow-sm">
        <h1 className="text-xl font-semibold text-gray-800">Visual Editor</h1>
        <div className="flex items-center space-x-4">
          <button className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition-colors">
            Publish Changes
          </button>
          <a href="/clients" className="text-gray-600 hover:text-gray-800">← Back to Clients</a>
        </div>
      </div>
      <div className="flex-1 overflow-hidden">
        <LiveVisualEditor clientId={clientId} />
      </div>
    </div>
  );
};

export default Editor;
